"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationsLink = void 0;
const react_1 = __importDefault(require("react"));
const intl_1 = require("@kyruus/intl");
const link_1 = __importDefault(require("@kyruus/link"));
const globals_1 = require("../../common/util/constants/globals");
const messages_1 = __importDefault(require("../../common/util/constants/messages"));
const styles_1 = require("./styles");
exports.LocationsLink = (0, intl_1.injectIntl)(({ ariaLabeledBy, href, locationCount, onClick, provider, track }) => {
    const handleClick = (e) => {
        e.preventDefault();
        track(globals_1.LOGGING.MESSAGE.VIEW_PROVIDER, {
            page_section: globals_1.LOGGING.PAGE_SECTION.LOCATIONS
        });
        onClick(e);
    };
    const linkId = `${provider.id}-locations-link`;
    return (react_1.default.createElement(styles_1.ViewMoreLinkContainer, null,
        react_1.default.createElement(link_1.default, { id: linkId, "data-testid": linkId, "aria-labelledby": `${ariaLabeledBy} ${linkId}`, href: href, onClick: handleClick },
            react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default.moreLocationsLink, { values: { count: locationCount } })))));
});
//# sourceMappingURL=locations-link.js.map